import React, { Component } from 'react'
import FixedView from '../FixedView'
import Collapsible from 'react-collapsible'
import { checkPermission, checkTranslation, translate } from '../../utils/useful'
import FramesPlusBut from './FramesPlusBut'
import importedIcons from '../inputs/icons'
import IntractionActionsList from '../IntractionActionsList'

export default class DeskFrame extends Component {

    state = {
        collapses: {},
        // collections: [
        //     { _id: 1, name: 'Antbuildz', addNew: true },
        //     { _id: 2, name: 'Yonnect', addNew: true, },
        //     { _id: 3, name: 'Dashboard', type: 'page', parent: 1 },
        //     { _id: 4, name: 'UI/UX team', type: 'collection', parent: 1 },
        //     { _id: 5, name: 'Planner', type: 'folder', parent: 1 },
        //     { _id: 6, name: 'Sub list', type: 'folder', parent: 5 }
        // ]
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? false : !this.state.collapses[key]
        this.setState({ collapses })
    }

    changeFrame = (item) => {
        // this.props.changePage(item)
        this.props.functionsHandler(null, 'changePage', [(item.key ?? item._id)])
        this.framesOptionsList.hideView()
    }

    createProject = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'frames', 'new'], { frame: this.props.frame, type: this.state.type, mode: this.state.mode })

        // this.props.functionsHandler(null, 'changePage', ['settings', 'newproject', 'new'])
        this.framesOptionsList.hideView()
    }

    handelFunction = (mfunction) => {
        if (this[mfunction]) {
            this[mfunction]()
        }
    }

    addPage = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'pages', 'new'])
        this.framesOptionsList.hideView()
    }

    addCollection = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'collections', 'new'])
        this.framesOptionsList.hideView()
    }

    showChildren = (parent, data, level) => {
        return (
            <div className={''}>

                {data?.map((item, index) => {
                    if (item.parents &&
                        // (checkPermission(this.props.permissions, `collection.${item._id}.view`))  &&
                        item.parents[item.parents.length - 1] == parent && !item.hideInDashboard)
                        return (
                            <div className={'w-100 ' + (level > 0 ? ' pld-2' : '')} key={index}>
                                <button onClick={() => { if (item.type != 'folder') { this.changeFrame(item) } else { this.changeCollapse(item._id) } }} className='flexcb w-100 p-2 hover-gray-no-filter br-5  transition-all'>
                                    <div className={"flexcb w-100 "}>
                                        <div className='flexc gray-filter w-100'>
                                            {item.type == 'folder' && (
                                                <div className='flexcc pld-1'>
                                                    <img className="transition-all " src={'/assets/icons/folder (1).png'} height={16} />
                                                </div>
                                            )}
                                            {item.type == 'page' && (
                                                <div className='flexcc'>
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#007aff20', color: '#007aff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>D</p>
                                                    </div>
                                                    {/* <img className="transition-all opacity-2" src={item.icon ?? '/assets/icons/assignee.svg'} height={16} /> */}
                                                </div>
                                            )}
                                            {item.type == 'recordClassifier' && (
                                                <div className='flexcc'>
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#007aff20', color: '#007aff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>S</p>
                                                    </div>
                                                    {/* <img className="transition-all opacity-2" src={item.icon ?? '/assets/icons/assignee.svg'} height={16} /> */}
                                                </div>
                                            )}
                                            {item.mode == 'planner' && (
                                                <div className='flexcc'>
                                                    {/* <img className="transition-all opacity-2" src={item.icon ?? '/assets/icons/useful/file.svg'} height={16} /> */}
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#7a00ff20', color: '#7a00ff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>P</p>
                                                    </div>
                                                </div>
                                            )}
                                            {item.mode == 'tasklist' && (
                                                <div className='flexcc'>
                                                    {/* <img className="transition-all opacity-2" src={item.icon ?? '/assets/icons/useful/file.svg'} height={16} /> */}
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#7a00ff20', color: '#7a00ff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>T</p>
                                                    </div>
                                                </div>
                                            )}
                                            <div className={'mld-3'}>
                                                <p className='font-size-12 text-semibold main-c3 '>{checkTranslation(item.title ?? item.name)}</p>
                                            </div>
                                        </div>
                                        <div>
                                            {item.type == 'folder' && (
                                                <div className="flexcc">
                                                    <FramesPlusBut width={this.props.width} colors={this.props.colors} frame={item._id} type={'task'} functionsHandler={this.props.functionsHandler} />
                                                    <img className={"transition flexcc " + ((this.state.collapses[item._id] == null || this.state.collapses[item._id] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </button>
                                {/* <div className={'w-100 ' + ((this.state.collapses[item._id] == null ? true : this.state.collapses[item._id]) ? "Collapsible-is-open" : '')}> */}
                                <Collapsible open={this.state.collapses[item._id] == null ? true : this.state.collapses[item._id]}>
                                    {this.showChildren(item._id, data, level + 1)}
                                </Collapsible>
                                {/* </div> */}
                            </div>
                        )
                })}
            </div>
        )
    }

    render() {
        let colors = this.props.colors
        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className={'flexcc pld-3 prd-4 py-1 br-5  ' + (colors?.iconInvert ? "dark-blur-bg" : 'light-blur-bg')}>
                        <div className='flexcc mrd-1'>
                            <img className={colors?.iconInvert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: colors.textColor }}>{checkTranslation(this.props.currentFrame?.name) ?? translate('Frames')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={this.props.language == 'fa' ? 170 : -9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3  ' >
                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            <div className="mt-0">
                                <div style={{ borderBottom: '1px solid #eee' }}>
                                    <button onClick={() => this.changeFrame('')} className='flexc w-100 p-2 hover-gray2 br-5 mb-2' >
                                        <div className="flexc">
                                            <img className="transition" src={'/images/icons/gaming-video.png'} height={18} />
                                            <div className='d-flex flex-column mld-3'>
                                                <p className={'font-size-12 weight-500 main-c3'}>{translate("Dashboard")}</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                                {/* <div className='px-2 mt-2'>
                                    <p className='font-size-14 weight-500 main-c3'>Collections</p>
                                </div> */}
                                {/* {Array.isArray(this.props.sections) && this.props.sections?.map((section, i) => {
                                    return (
                                        <div className="w-100 py-1 bb-gray">
                                            <button className="flexcb w-100 p-2 hover-gray br-5" onClick={() => this.changeCollapse(section.key)}>
                                                <div className="flexc">
                                                    <p className="font-size-12 weight-500 main-c3 " style={{}}>{checkTranslation(section.name)}</p>
                                                </div>
                                                <div className='flexc'>
                                                    {section.addNew && (
                                                        <div className="mx-1" onClick={(e) => { e.stopPropagation(); this.handelFunction(section.addNew) }}>
                                                            <div className='br-20' style={{ background: '#ddd' }}>
                                                                <img className={"transition flexcc "} width={18} src='/assets/icons/plus.svg' />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="">
                                                        <img className={"transition flexcc " + ((this.state.collapses[section.key] == null || this.state.collapses[section.key] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                                    </div>
                                                </div>
                                            </button>
                                            <Collapsible open={this.state.collapses[section.key] == null ? true : this.state.collapses[section.key]}>
                                                <div className='my-1'>
                                                    {this.props.modules.map((item, index) => {
                                                        if (section.key == item.section && !item.hideInDashboard)
                                                            return (
                                                                <div className='w-100 my-1' key={index}>
                                                                    <button onClick={() => this.changeFrame(item)} className='flexc w-100 p-2 hover-gray br-5 transition-all'>
                                                                        <div className='flexcc'>
                                                                            <img className="transition-all" src={item.icon ?? '/assets/icons/applets/general/play-games.png'} height={22} />
                                                                        </div>

                                                                        <div className='mld-3'>
                                                                            <p className='font-size-12 main-c3 '>{checkTranslation(item.title ?? item.name)}</p>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            )
                                                    })}
                                                </div>
                                            </Collapsible>
                                        </div>
                                    )
                                })} */}
                                {this.props.frames?.map((section, i) => {
                                    if (section
                                        // && (checkPermission(this.props.permissions, `collection.${section._id}.view`))
                                        && (section.parents == null || section.parents.length == 0)) {
                                        return (
                                            <div className="w-100 py-1 bb-gray">
                                                <button className="flexcb w-100 p-2  br-5" onClick={() => this.changeFrame(section)} >
                                                    <div className="flexc text-start">
                                                        <img className="transition br-20" src={'/assets/profile-def.png'} height={20} width={20} />
                                                        <div>
                                                            <p className="font-size-12 mld-3 weight-600 main-c3 " style={{}}>{checkTranslation(section.name)}</p>
                                                            {/* <p className="font-size-10 mld-3  main-c3 " style={{}}>Applet Name</p> */}
                                                        </div>
                                                    </div>
                                                    <div className='flexc'>
                                                        <FramesPlusBut type='task' colors={this.props.colors} width={this.props.width} frame={section._id} functionsHandler={this.props.functionsHandler} />
                                                        <div className="">
                                                            <img className={"transition flexcc " + ((this.state.collapses[section._id] == null || this.state.collapses[section._id] == true) ? "" : "rotate-90-rev")} onClick={(e) => { e.stopPropagation(); this.changeCollapse(section._id) }} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                                        </div>
                                                    </div>
                                                </button>
                                                <Collapsible open={this.state.collapses[section._id] == null ? true : this.state.collapses[section._id]}>
                                                    {this.showChildren(section._id, this.props.frames, 0)}
                                                </Collapsible>
                                            </div>
                                        )
                                    }
                                })}
                                {/* <button className='px-3 mt-1 py-2' onClick={() => this.createProject()}>
                                    <p className='text-smaller text-semibold' style={{ color: '#007aff' }}>+ New Collection</p>
                                </button> */}
                                <div className='pt-2'>
                                    {/* <IntractionActionsList onClick={() => this.createProject()} language={this.props.language} data={{ title: 'New Collection', icon: importedIcons.plus }} /> */}
                                    {/* <IntractionActionsList onClick={() => this.createProject()} language={this.props.language} data={{ title: 'New Project', icon: importedIcons.plus }} /> */}
                                    <FramesPlusBut type='frame' colors={this.props.colors} fullSize={true} width={this.props.width} functionsHandler={this.props.functionsHandler} />

                                </div>
                            </div>
                        </div >
                    </div >
                </FixedView >
            </div >
        )
    }
}
